// Translations for EN, AR and FR
export const WHATSAPP_NUMBER = "96178866746";
export const WHATSAPP_DISPLAY = "+961 78 866 746";
export const INSTAGRAM_URL = "https://www.instagram.com/bobserviceslb";
export const FACEBOOK_URL = "https://www.facebook.com/bobshoppingserviceslb";
export const CANONICAL_ORIGIN = "https://bobserviceslb.com";

export const buildWhatsAppUrl = (message = "", number = WHATSAPP_NUMBER) => {
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${number}${encoded ? `?text=${encoded}` : ""}`;
};

const common_strings = {
  en: {
    whatsappMsg: "Hi BOB Services LB, I want to start shopping.",
    whatsappCountryMsg: (country) => `Hi BOB, I'd like to order something from ${country}. Here is the product link:`,
    whatsappStoreMsg: (store, country) => `Hi BOB, I'd like to order from ${store} (${country}). Here is the product link:`,
  },
  ar: {
    whatsappMsg: "مرحبا BOB، أريد بدء التسوق.",
    whatsappCountryMsg: (country) => `مرحبا BOB، أريد طلب منتج من ${country}. الرابط:`,
    whatsappStoreMsg: (store, country) => `مرحبا BOB، أريد الطلب من ${store} (${country}). الرابط:`,
  },
  fr: {
    whatsappMsg: "Bonjour BOB Services LB, je souhaite commencer à acheter.",
    whatsappCountryMsg: (country) => `Bonjour BOB, je souhaite commander un article depuis ${country}. Voici le lien du produit :`,
    whatsappStoreMsg: (store, country) => `Bonjour BOB, je souhaite commander chez ${store} (${country}). Voici le lien du produit :`,
  },
};

export const translations = {
  en: {
    nav: {
      home: "Home",
      howItWorks: "How It Works",
      countries: "Countries",
      why: "Why Us",
      rates: "Rates",
      team: "Meet Our Team",
      faq: "FAQ",
      contact: "Contact",
      startShopping: "Shop & Ship",
      shippingOnly: "Shipping Only",
      stockStore: "BOB Store",
      signIn: "Sign in",
      myAccount: "My Account",
      myOrders: "Bob Store Orders",
      myFinancial: "Dashboard",
      logout: "Log out",
    },
    hero: {
      badge: "Lebanon's Premium Forwarding Service",
      titlePre: "Shop the world.",
      titleHighlight: "Delivered to Lebanon.",
      subtitle: "We buy, collect, and ship products from Turkey, China, USA, UAE, France and the UK — straight to your door. Fast, trusted, and built for Lebanon.",
      cta1: "Shop & Ship",
      cta2: "Chat on WhatsApp",
      ctaStore: "BOB Store",
      trustPill: "Trusted by 27,000+ customers across Lebanon",
      stats: [
        { k: "27K+", v: "Parcels Delivered" },
        { k: "6", v: "Source countries" },
        { k: "15 Days", v: "Average Shipping Time" },
        { k: "24/7", v: "Live support" },
      ],
      badgeSecured: "Secured",
      badgeAir: "Air Freight",
      badgeSea: "Sea Freight",
      heroTagline: "Land & Sea Shipping",
    },
    how: {
      eyebrow: "How It Works",
      title: "Four simple steps to your doorstep.",
      subtitle: "From the moment you send us a link to the moment your parcel arrives in Lebanon — we handle every detail.",
      steps: [
        { n: "01", title: "Choose your country", desc: "Pick from Turkey, China, USA, UAE, France or the UK — wherever your favorite store is." },
        { n: "02", title: "Send the product link", desc: "Share the item via WhatsApp with size, color and quantity. We confirm the price and fees." },
        { n: "03", title: "We buy or receive it", desc: "Our team purchases on your behalf or receives your package at our local warehouse." },
        { n: "04", title: "Delivered to Lebanon", desc: "We consolidate, ship by air, clear customs, and deliver to your door anywhere in Lebanon." },
      ],
    },
    countries: {
      eyebrow: "Shop by Country",
      title: "Six markets. One trusted partner.",
      subtitle: "Whether it's Istanbul's boutiques or Shenzhen's electronics — we bring the world to you.",
      shopCta: "Shop from",
      items: [
        { code: "TR", name: "Turkey", tagline: "Fashion, leather, home textiles" },
        { code: "CN", name: "China", tagline: "Electronics, tech, wholesale" },
        { code: "US", name: "USA", tagline: "Sneakers, beauty, designer" },
        { code: "AE", name: "UAE", tagline: "Gold, perfumes, premium brands" },
        { code: "FR", name: "France", tagline: "Luxury, cosmetics, couture" },
        { code: "GB", name: "UK", tagline: "High street, streetwear, gadgets" },
      ],
    },
    why: {
      eyebrow: "Why Choose Us",
      title: "A forwarding partner built on trust.",
      subtitle: "We obsess over the details so your parcel arrives on time, every time.",
      items: [
        { title: "Fast Delivery", desc: "Most parcels arrive in Lebanon within 10–15 business days via reliable air freight." },
        { title: "Trusted courier", desc: "Fully tracked shipments, secure handling and on-ground customs clearance." },
        { title: "Best Prices", desc: "Transparent pricing with no hidden fees and bundle discounts." },
        { title: "Reliable support", desc: "Real humans on WhatsApp — ready to help in Arabic, English or French." },
      ],
    },
    categories: {
      eyebrow: "Featured Categories",
      title: "What our customers ship every day.",
      items: ["Fashion", "Electronics", "Beauty", "Home", "Gifts", "Accessories", "Sneakers", "Perfumes"],
    },
    testimonials: {
      eyebrow: "Testimonials",
      title: "Loved by shoppers across Lebanon.",
      items: [
        { quote: "Ordered a PlayStation 5 from the USA. Arrived in Beirut in 8 days, perfectly packed. Cheapest price I found anywhere.", author: "Karim H.", role: "Beirut" },
        { quote: "I use BOB every month for my Istanbul fashion haul. The team is so responsive on WhatsApp — feels like having a personal shopper.", author: "Layla M.", role: "Jounieh" },
        { quote: "French pharmacy skincare that's impossible to find locally — BOB got it to me in a week. My new go-to forwarder.", author: "Nour A.", role: "Tripoli" },
        { quote: "Transparent pricing, real tracking, and they handled customs without a single issue. Hands down the most professional service in Lebanon.", author: "Ziad K.", role: "Saida" },
        { quote: "Shipped 4 boxes of clothes from China. The consolidation saved me over 40% compared to shipping separately. Brilliant.", author: "Maya S.", role: "Zahle" },
        { quote: "Bought an iPhone from Dubai and it landed in Lebanon faster than any local retailer could restock. Incredible service.", author: "Omar D.", role: "Byblos" },
      ],
    },
    faq: {
      eyebrow: "FAQ",
      title: "Everything you want to know.",
      items: [
        {
          q: "How does ordering work?",
          a: "Send us the product link via WhatsApp with your preferred size, color and quantity. We confirm the item price, shipping fee and our service fee upfront. Once you approve and pay, we buy it on your behalf and handle everything until it reaches your door in Lebanon.",
        },
        {
          q: "How long does shipping to Lebanon take?",
          a: "Most shipments from Turkey, UAE, France, and the UK arrive within 10–15 business days. Shipments from the USA and China take 20–25 days by air, and 50–70 days by sea.",
        },
        {
          q: "What payment options are available?",
          a: "We accept cash on delivery inside Lebanon, USD transfer via OMT / Whish Money / BoB Wallet, and bank transfer for large orders. A 50% advance payment of the purchase value is required before buying items from abroad.",
        },
        {
          q: "Which countries do you ship from?",
          a: "We currently source and ship from Turkey, China, USA, UAE, France and the UK. If you need something from a country not listed, message us on WhatsApp — we may be able to help.",
        },
        {
          q: "Do you deliver everywhere in Lebanon?",
          a: "Yes. We deliver to Beirut, Mount Lebanon, North, South, Bekaa and all major cities. Delivery fees vary by location and are always confirmed before shipping.",
        },
        {
          q: "What if my item is damaged or lost?",
          a: "Every parcel is tracked and handled by trusted couriers. In the rare event of damage during transit, we work with our partners to ensure you are compensated or the item is replaced.",
        },
      ],
      stillQuestions: "Still have questions?",
      stillQuestionsSub: "Message us directly — we typically reply in minutes.",
    },
    finalCta: {
      eyebrow: "Ready to start?",
      title: "Your next parcel is one message away.",
      subtitle: "Tell us what you want, where you want it from, and we'll handle the rest.",
      cta1: "Shop & Ship",
      cta2: "Message us on WhatsApp",
    },
    footer: {
      tagline: "Premium international shopping & courier service — from the world's biggest markets to every corner of Lebanon.",
      quickLinks: "Quick Links",
      contact: "Contact",
      contacts: "Our Numbers",
      follow: "Follow",
      office: "Office",
      email: "Email",
      viewOnMap: "View on map",
      rights: "All rights reserved.",
      madeIn: "Designed with care in Lebanon.",
      address: "Serving all Lebanon",
    },
    rates: {
      eyebrow: "Rates & Services",
      title: "Full shipping rates — updated regularly.",
      subtitle: "Browse our complete, interactive pricing sheet by country, category and shipping method.",
      preview: "View Rates",
      view: "View Rates",
      openLink: "Open full page",
      download: "Download PDF",
      noteTitle: "Service fee",
      noteBody: "A 12.5% service fee applies on the invoice value. Sea freight available for Turkey & China; air freight available for all countries.",
    },
    videos: {
      eyebrow: "Behind the scenes",
      title: "Watch us in action.",
      subtitle: "Real glimpses from our warehouses, team and daily operations.",
      soon: "Videos coming soon.",
    },
    team: {
      eyebrow: "About Us",
      title: "Meet Our Team",
      subtitle: "Our success is driven by a team of dedicated professionals working together to deliver the best results for our clients.",
    },
    calculator: {
      eyebrow: "Shipping Calculator",
      title: "Estimate your shipping cost.",
      subtitle: "Quick, transparent estimates based on our live rate sheet.",
      method: "Shipping method",
      category: "Product category",
      weight: "Weight",
      weightUnit: "kg",
      volume: "Volume",
      volumeUnit: "m³ (cbm)",
      invoice: "Invoice value (optional)",
      invoiceHint: "Used to calculate the 12.5% service fee.",
      transit: "Transit time",
      shippingCost: "Shipping cost",
      serviceFee: "Service fee (12.5%)",
      total: "Estimated total",
      orderCta: "Order this shipment",
      disclaimer: "Estimates are for guidance only — final price confirmed on WhatsApp.",
      enterWeight: "Enter a weight above 0.",
    },
    devCredit: {
      preLabel: "Developed by",
      name: "BOB Services LB",
      cta: "Need a website like this?",
      waLabel: "Contact us",
    },
    common: common_strings.en,
    countryPage: {
      back: "Back to home",
      breadcrumbHome: "Home",
      breadcrumbCountries: "Countries",
      intro: "Curated stores",
      storesCount: "stores",
      currency: "Currency",
      searchPlaceholder: "Search stores or categories",
      visitStore: "Visit store",
      orderVia: "Order via WhatsApp",
      cantFind: "Can't find your store?",
      cantFindDesc: "Send us any product link — we'll get it from any online store worldwide.",
      sendLink: "Send us a link",
      otherCountries: "Explore other countries",
      shopFrom: "Shop from",
      allCategories: "All",
      noResults: "No stores match your search.",
      popular: "Popular right now",
      popularSub: "What shoppers from Lebanon are ordering most this week.",
      popularBadge: "Popular",
      lead: {
        eyebrow: "Request a quote",
        title: "Send us your product link",
        subtitle: "Fill in the form and we'll come back to you on WhatsApp within minutes with the best price.",
        name: "Your name",
        namePlaceholder: "e.g. Karim Haddad",
        phone: "WhatsApp number",
        phonePlaceholder: "+961 70 123 456",
        link: "Product link",
        linkPlaceholder: "https://...",
        submit: "Submit request",
        submitting: "Sending...",
        successTitle: "Request received",
        successMsg: "We'll reply on WhatsApp shortly. Opening chat now…",
        errorMsg: "Something went wrong. Please try WhatsApp directly.",
        validationRequired: "This field is required.",
        validationLink: "Please enter a valid URL starting with http or https.",
        privacy: "By submitting, you agree to be contacted via WhatsApp.",
      },
      chinaSuppliersTitle: "China Suppliers Database",
      chinaSuppliersDesc: "Browse our verified directory of trusted factories, manufacturers and wholesalers across China.",
      chinaSuppliersCta: "Open Suppliers Database",
    },
    embeds: {
      back: "Back",
      copyLink: "Copy link",
      copied: "Copied!",
      share: "Share",
      shippingOnly: "Shipping Only",
      shippingRates: "Shipping Rates",
      chinaSuppliers: "China Suppliers Database",
    },
    store: {
      eyebrow: "BOB Store",
      pageTitle: "Available products — ready to deliver.",
      pageSubtitle: "Premium products in stock with 50% OFF promo pricing. Tap any item to view details, add to cart, or message us directly.",
      previewEyebrow: "BOB Store",
      previewTitle: "Shop premium products — straight from BOB.",
      previewSubtitle: "A curated selection from our store, ready to ship across Lebanon in 24–48 hours.",
      previewViewAll: "View full store",
      recentlyViewedEyebrow: "For you",
      recentlyViewedTitle: "Recently viewed",
      recentlyViewedPrev: "Previous items",
      recentlyViewedNext: "Next items",
      recentlyViewedRemove: "Remove from Recently Viewed",
      bannerEyebrow: "Limited time promo",
      bannerHeadline: "50% OFF",
      bannerSub: "On All Products",
      bannerFootnote: "Sale automatically applied",
      categoryAll: "All",
      categories: {
        clothing: "Clothing & Shoes",
        perfumes: "Perfumes",
        cosmetics: "Supplements & Cosmetics",
        others: "Others",
        authentic: "Authentic Brands",
      },
      searchPlaceholder: "Search by name or #number",
      availableOnly: "In stock only",
      sortBy: "Sort by",
      sortDefault: "Sort: Default",
      sortPriceLow: "Price: Low to High",
      sortPriceHigh: "Price: High to Low",
      available: "Available",
      outOfStock: "Out of Stock",
      addToCart: "Add to Cart",
      addedToCart: "Added to cart",
      inquireOnWhatsApp: "Ask on WhatsApp",
      share: "Share",
      copyLink: "Copy link",
      copied: "Copied!",
      cartTitle: "Cart",
      cartEmpty: "Your cart is empty",
      cartEmptyHint: "Browse our store and add your favorites.",
      continueShopping: "Continue shopping",
      clearCart: "Clear cart",
      subtotal: "Subtotal",
      shippingLebanon: "Delivery (Lebanon) — 24–48 hours",
      total: "Total",
      checkoutCta: "Checkout",
      policyTitle: "Return & Exchange Policy",
      policyBody:
        "Returns are not allowed. However, you may exchange the product for another product within 3 days of receiving the order, with payment of the delivery fee.",
      policyShort: "No returns. Exchange within 3 days (delivery fee applies).",
      quantity: "Quantity",
      description: "Description",
      backToStore: "Back to store",
      noResults: "No products match your filters.",
      noResultsHint: "Try removing a filter or clearing your search.",
      productNotFound: "Product not found.",
      relatedTitle: "You may also like",
      badgeNew: "New",
      badgeLimited: "Limited",
      badgeAuthentic: "Authentic Product",
      priceTBD: "Price soon",
      priceTBDFull: "Price to be updated",
      colorLabel: "Color",
      selectColor: "Select color",
      colorOutOfStock: "Out of stock",
      maxStockReached: "Maximum available quantity reached",
      sizeLabel: "Size",
      selectSize: "Select size",
      sizesAvailable: "sizes available",
      pieceLeft: "piece left",
      piecesLeft: "pieces left",
      trust1: "Genuine products",
      trust2: "Lebanon-wide delivery",
      trust3: "WhatsApp support 24/7",
      helpOnWhatsapp: "Need help? Contact us on WhatsApp",
      inquireMsg: "Hi BOB Services LB, I'm interested in product #{id} — {name}.\nLink: {url}",
      checkout: {
        title: "Checkout",
        yourOrder: "Your order",
        contactInfo: "Customer information",
        paymentMethods: "Payment method",
        omt: "OMT",
        omtSub: "Send via OMT branches",
        whish: "Whish Money",
        whishSub: "Mobile payment app",
        cod: "Cash on Delivery",
        codSub: "Pay when you receive",
        fullName: "Full name",
        phone: "Phone number",
        address: "Address (optional)",
        city: "City / area (optional)",
        notes: "Order notes (optional)",
        notesPlaceholder: "Anything we should know about your order?",
        placeOrder: "Place Order",
        placing: "Placing your order...",
        orderSuccess: "Order received!",
        orderSuccessMsg: "Thank you! Order {order_no} confirmed. We'll contact you shortly on WhatsApp to finalize delivery.",
        orderError: "Something went wrong. Please try again or message us on WhatsApp.",
        unavailableItemsMessage: "Some items are no longer available. Please remove the unavailable items to continue.",
        unavailableItemsBadge: "Unavailable",
        removeUnavailableCta: "Remove unavailable items",
        requiredField: "This field is required",
        invalidPhone: "Please enter a valid phone number",
        close: "Close",
        backToShopping: "Back to shopping",
        items: "items",
        item: "item",
        qtyLabel: "Qty",
      },
    },
    shein: {
      navPillLabel: "SHEIN",
      heroTitle: "SHEIN Collection",
      heroSubtitle: "Trendy fashion, beauty and lifestyle picks — handpicked from SHEIN and delivered across Lebanon in 24–48 hours.",
      discountChip: "30% OFF on all SHEIN products",
      backToBobStore: "Back to BOB Store",
      featureFastShip: "24–48h delivery in Lebanon",
      featureSecure: "Secure checkout & order tracking",
      featureCount: "{count} products in stock",
      searchPlaceholder: "Search SHEIN products…",
      subcatAll: "All SHEIN",
      featuredEyebrow: "Featured Looks",
      featuredHint: "Tap to shop the look",
      featuredShopCta: "Shop now",
      featuredGoTo: "Go to slide",
    },
  },
  ar: {
    nav: {
      home: "الرئيسية",
      howItWorks: "كيف نعمل",
      countries: "الدول",
      why: "لماذا نحن",
      rates: "الأسعار",
      team: "تعرّف على فريقنا",
      faq: "الأسئلة",
      contact: "تواصل",
      startShopping: "تسوّق واشحن",
      shippingOnly: "الشحن فقط",
      stockStore: "متجر BOB",
      signIn: "تسجيل الدخول",
      myAccount: "حسابي",
      myOrders: "طلبات متجر BOB",
      myFinancial: "لوحة التحكم",
      logout: "تسجيل الخروج",
    },
    hero: {
      badge: "خدمة الشحن الأولى في لبنان",
      titlePre: "تسوّق من العالم.",
      titleHighlight: "ونوصل إلى لبنان.",
      subtitle: "نشتري، نستلم، ونشحن المنتجات من تركيا والصين وأميركا والإمارات وفرنسا وبريطانيا — مباشرة إلى بابك. سريع، موثوق، ومصمّم للبنان.",
      cta1: "تسوّق واشحن",
      cta2: "واتساب",
      ctaStore: "متجر BOB",
      trustPill: "أكثر من 27,000 عميل في لبنان يثقون بنا",
      stats: [
        { k: "+27 ألف", v: "طرد تم تسليمه" },
        { k: "6", v: "دول مصدر" },
        { k: "15 يوم", v: "متوسط مدة الشحن" },
        { k: "24/7", v: "دعم مباشر" },
      ],
      badgeSecured: "آمن",
      badgeAir: "شحن جوي",
      badgeSea: "شحن بحري",
      heroTagline: "شحن بري وبحري",
    },
    how: {
      eyebrow: "كيف نعمل",
      title: "أربع خطوات بسيطة حتى باب منزلك.",
      subtitle: "من لحظة إرسال الرابط حتى وصول الطرد إلى لبنان — نتولى كل التفاصيل.",
      steps: [
        { n: "01", title: "اختر البلد", desc: "اختر من تركيا، الصين، أميركا، الإمارات، فرنسا أو بريطانيا — أينما يوجد متجرك المفضّل." },
        { n: "02", title: "أرسل رابط المنتج", desc: "شاركنا الرابط عبر واتساب مع المقاس واللون والكمية. نؤكد لك السعر والرسوم." },
        { n: "03", title: "نشتري أو نستلم", desc: "نشتري نيابة عنك أو نستقبل طردك في المستودع المحلي." },
        { n: "04", title: "توصيل إلى لبنان", desc: "نجمع الطرود، نشحن جوًّا، ننهي الجمارك، ونوصل إلى منزلك في أي منطقة." },
      ],
    },
    countries: {
      eyebrow: "تسوّق حسب البلد",
      title: "ست أسواق. شريك واحد موثوق.",
      subtitle: "سواء أكانت بوتيكات إسطنبول أم إلكترونيات شنجن — نجلب العالم إليك.",
      shopCta: "تسوّق من",
      items: [
        { code: "TR", name: "تركيا", tagline: "أزياء، جلود، مفروشات" },
        { code: "CN", name: "الصين", tagline: "إلكترونيات، جملة، تقنية" },
        { code: "US", name: "أميركا", tagline: "أحذية، تجميل، ماركات" },
        { code: "AE", name: "الإمارات", tagline: "ذهب، عطور، ماركات فاخرة" },
        { code: "FR", name: "فرنسا", tagline: "فخامة، تجميل، أزياء راقية" },
        { code: "GB", name: "بريطانيا", tagline: "ستريت وير، أجهزة، أزياء" },
      ],
    },
    why: {
      eyebrow: "لماذا نحن",
      title: "شريك شحن مبني على الثقة.",
      subtitle: "نهتم بأدق التفاصيل ليصل طردك في الوقت المناسب دائمًا.",
      items: [
        { title: "توصيل سريع", desc: "معظم الطرود تصل إلى لبنان خلال 10–15 يوم عمل عبر شحن جوي موثوق." },
        { title: "ناقل موثوق", desc: "تتبع كامل للشحنات، تعامل آمن، وتخليص جمركي احترافي." },
        { title: "أفضل الأسعار", desc: "تسعير شفاف بدون رسوم خفية وخصومات على الطرود المجمّعة." },
        { title: "دعم موثوق", desc: "فريق حقيقي على واتساب — جاهز بالعربية والإنكليزية والفرنسية." },
      ],
    },
    categories: {
      eyebrow: "الفئات الأكثر طلبًا",
      title: "ما يشحنه عملاؤنا يوميًّا.",
      items: ["أزياء", "إلكترونيات", "تجميل", "منزل", "هدايا", "إكسسوارات", "أحذية", "عطور"],
    },
    testimonials: {
      eyebrow: "آراء العملاء",
      title: "محبوبون في كل لبنان.",
      items: [
        { quote: "طلبت بلايستيشن 5 من أميركا. وصلت بيروت خلال 8 أيام بتغليف ممتاز، وبأرخص سعر وجدته.", author: "كريم ح.", role: "بيروت" },
        { quote: "أستخدم BOB شهريًا لطلبات الأزياء من إسطنبول. الفريق سريع الرد على واتساب — كأنه متسوّق شخصي.", author: "ليلى م.", role: "جونية" },
        { quote: "منتجات تجميل فرنسية يصعب إيجادها محليًا — وصلتني خلال أسبوع. صار شريكي الدائم.", author: "نور ع.", role: "طرابلس" },
        { quote: "تسعير شفاف، تتبع دقيق، وتخليص جمركي بدون أي مشكلة. الأكثر احترافية في لبنان.", author: "زياد ك.", role: "صيدا" },
        { quote: "شحنت 4 صناديق ملابس من الصين. التجميع وفّر علي أكثر من 40%. ممتاز.", author: "مايا س.", role: "زحلة" },
        { quote: "اشتريت آيفون من دبي ووصلني أسرع من المحلات المحلية. خدمة مذهلة.", author: "عمر د.", role: "جبيل" },
      ],
    },
    faq: {
      eyebrow: "الأسئلة الشائعة",
      title: "كل ما تحتاج معرفته.",
      items: [
        {
          q: "كيف يعمل الطلب؟",
          a: "أرسل لنا رابط المنتج عبر واتساب مع المقاس واللون والكمية. نؤكد السعر ورسوم الشحن وعمولتنا مسبقًا. بمجرد الموافقة والدفع، نشتريه ونتولى كل شيء حتى يصل إلى بابك في لبنان.",
        },
        {
          q: "كم يستغرق الشحن إلى لبنان؟",
          a: "معظم الشحنات من تركيا والإمارات وفرنسا وبريطانيا تصل خلال 10–15 يوم عمل. الشحنات من أميركا والصين تستغرق 20–25 يومًا جوًّا، و50–70 يومًا بحرًا.",
        },
        {
          q: "ما خيارات الدفع المتاحة؟",
          a: "نقبل الدفع عند الاستلام داخل لبنان، وتحويل الدولار عبر OMT / Whish Money / محفظة BoB، والتحويل المصرفي للطلبات الكبيرة. يُطلب دفع مقدّم بنسبة 50% من قيمة الشراء قبل شراء المنتجات من الخارج.",
        },
        {
          q: "من أي دول تشحنون؟",
          a: "نشحن حاليًا من تركيا، الصين، أميركا، الإمارات، فرنسا وبريطانيا. إذا احتجت دولة غير مذكورة، راسلنا على واتساب وقد نتمكن من المساعدة.",
        },
        {
          q: "هل توصلون إلى كل لبنان؟",
          a: "نعم. نوصل إلى بيروت وجبل لبنان والشمال والجنوب والبقاع وكل المدن الرئيسية. رسوم التوصيل تختلف حسب المنطقة ويتم تأكيدها قبل الشحن.",
        },
        {
          q: "ماذا لو تضرر الطرد أو فُقد؟",
          a: "كل طرد يتم تتبعه ومناولته عبر شركاء موثوقين. في حال حدوث ضرر نادر أثناء الشحن، نتعاون مع شركائنا لضمان التعويض أو الاستبدال.",
        },
      ],
      stillQuestions: "هل لديك أسئلة أخرى؟",
      stillQuestionsSub: "راسلنا مباشرة — نرد عادة خلال دقائق.",
    },
    finalCta: {
      eyebrow: "جاهز للبدء؟",
      title: "طردك التالي يبعد رسالة واحدة.",
      subtitle: "أخبرنا بما تريد ومن أين، ونحن نتولى الباقي.",
      cta1: "تسوّق واشحن",
      cta2: "راسلنا على واتساب",
    },
    footer: {
      tagline: "خدمة تسوّق وشحن دولية بمستوى عالمي — من أكبر الأسواق إلى كل ركن في لبنان.",
      quickLinks: "روابط سريعة",
      contact: "تواصل",
      contacts: "أرقامنا",
      follow: "تابعنا",
      office: "المكتب",
      email: "البريد الإلكتروني",
      viewOnMap: "عرض على الخريطة",
      rights: "جميع الحقوق محفوظة.",
      madeIn: "صُمّم بعناية في لبنان.",
      address: "نخدم كل لبنان",
    },
    rates: {
      eyebrow: "الأسعار والخدمات",
      title: "لائحة الأسعار الكاملة — محدّثة باستمرار.",
      subtitle: "تصفّح لائحة أسعارنا التفاعلية حسب الدولة والفئة وطريقة الشحن.",
      preview: "عرض الأسعار",
      view: "عرض الأسعار",
      openLink: "فتح الصفحة كاملة",
      download: "تحميل PDF",
      noteTitle: "رسوم الخدمة",
      noteBody: "تطبَّق رسوم خدمة بنسبة 12.5% على قيمة الفاتورة. الشحن البحري متاح لتركيا والصين؛ والشحن الجوي متاح لجميع الدول.",
    },
    videos: {
      eyebrow: "من وراء الكواليس",
      title: "شاهدنا أثناء العمل.",
      subtitle: "لقطات حقيقية من مستودعاتنا وفريقنا وعمليّاتنا اليومية.",
      soon: "الفيديوهات قريبًا.",
    },
    team: {
      eyebrow: "من نحن",
      title: "تعرّف على فريقنا",
      subtitle: "نجاحنا مبني على فريق من المحترفين المخلصين الذين يعملون معًا لتقديم أفضل النتائج لعملائنا.",
    },
    calculator: {
      eyebrow: "حاسبة الشحن",
      title: "احسب تكلفة شحنتك.",
      subtitle: "تقدير سريع وشفاف مبني على لائحة أسعارنا.",
      method: "طريقة الشحن",
      category: "فئة المنتج",
      weight: "الوزن",
      weightUnit: "كغ",
      volume: "الحجم",
      volumeUnit: "م³",
      invoice: "قيمة الفاتورة (اختياري)",
      invoiceHint: "لحساب رسوم الخدمة 12.5%.",
      transit: "مدة الشحن",
      shippingCost: "تكلفة الشحن",
      serviceFee: "رسوم الخدمة (12.5%)",
      total: "التقدير الإجمالي",
      orderCta: "اطلب هذه الشحنة",
      disclaimer: "التقديرات استرشادية فقط — السعر النهائي يُؤكَّد عبر واتساب.",
      enterWeight: "أدخل وزنًا أكبر من 0.",
    },
    devCredit: {
      preLabel: "تطوير",
      name: "BOB Services LB",
      cta: "تحتاج موقعًا مشابهًا؟",
      waLabel: "تواصل معنا",
    },
    common: common_strings.ar,
    countryPage: {
      back: "العودة إلى الرئيسية",
      breadcrumbHome: "الرئيسية",
      breadcrumbCountries: "الدول",
      intro: "متاجر مختارة",
      storesCount: "متجر",
      currency: "العملة",
      searchPlaceholder: "ابحث عن متجر أو فئة",
      visitStore: "زيارة المتجر",
      orderVia: "اطلب عبر واتساب",
      cantFind: "لم تجد متجرك؟",
      cantFindDesc: "أرسل لنا رابط أي منتج — نحضره لك من أي متجر إلكتروني حول العالم.",
      sendLink: "أرسل الرابط",
      otherCountries: "استكشف دولًا أخرى",
      shopFrom: "تسوّق من",
      allCategories: "الكل",
      noResults: "لا توجد متاجر مطابقة للبحث.",
      popular: "الأكثر طلبًا حاليًا",
      popularSub: "ما يطلبه الزبائن في لبنان الأكثر هذا الأسبوع.",
      popularBadge: "شائع",
      lead: {
        eyebrow: "طلب عرض سعر",
        title: "أرسل لنا رابط المنتج",
        subtitle: "املأ النموذج وسنعاود التواصل معك على واتساب خلال دقائق بأفضل سعر.",
        name: "الاسم",
        namePlaceholder: "مثال: كريم حداد",
        phone: "رقم واتساب",
        phonePlaceholder: "+961 70 123 456",
        link: "رابط المنتج",
        linkPlaceholder: "https://...",
        submit: "إرسال الطلب",
        submitting: "جارٍ الإرسال...",
        successTitle: "تم استلام الطلب",
        successMsg: "سنرد عليك على واتساب قريبًا. جارٍ فتح المحادثة...",
        errorMsg: "حدث خطأ. يرجى المحاولة عبر واتساب مباشرة.",
        validationRequired: "هذا الحقل مطلوب.",
        validationLink: "يرجى إدخال رابط صالح يبدأ بـ http أو https.",
        privacy: "بالإرسال، أنت توافق على التواصل معك عبر واتساب.",
      },
      chinaSuppliersTitle: "قاعدة بيانات الموردين في الصين",
      chinaSuppliersDesc: "تصفّح دليلنا الموثّق للمصانع والمصنّعين وتجّار الجملة المعتمدين في الصين.",
      chinaSuppliersCta: "فتح قاعدة الموردين",
    },
    embeds: {
      back: "عودة",
      copyLink: "نسخ الرابط",
      copied: "تم النسخ!",
      share: "مشاركة",
      shippingOnly: "الشحن فقط",
      shippingRates: "أسعار الشحن",
      chinaSuppliers: "قاعدة بيانات الموردين في الصين",
    },
    store: {
      eyebrow: "متجر BOB",
      pageTitle: "منتجات متوفرة — جاهزة للتوصيل.",
      pageSubtitle: "منتجات فاخرة متوفرة في المتجر بخصم 50%. اضغط على أي منتج لعرض التفاصيل، الإضافة للسلة، أو التواصل مباشرة.",
      recentlyViewedEyebrow: "مخصّص لك",
      recentlyViewedTitle: "شاهدتها مؤخراً",
      recentlyViewedPrev: "العناصر السابقة",
      recentlyViewedNext: "العناصر التالية",
      recentlyViewedRemove: "إزالة من المنتجات المعروضة مؤخراً",
      bannerEyebrow: "عرض لفترة محدودة",
      bannerHeadline: "خصم 50%",
      bannerSub: "على جميع المنتجات",
      bannerFootnote: "الخصم مطبّق تلقائياً",
      categoryAll: "الكل",
      categories: {
        clothing: "الملابس والأحذية",
        perfumes: "العطورات",
        cosmetics: "المكمّلات ومستحضرات التجميل",
        others: "غير ذلك",
        authentic: "منتجات أصلية",
      },
      searchPlaceholder: "ابحث بالاسم أو رقم #",
      availableOnly: "المتوفر فقط",
      sortBy: "ترتيب حسب",
      sortDefault: "الترتيب: افتراضي",
      sortPriceLow: "السعر: من الأقل",
      sortPriceHigh: "السعر: من الأعلى",
      available: "متوفر",
      outOfStock: "غير متوفر",
      addToCart: "أضف للسلة",
      addedToCart: "تمت الإضافة",
      inquireOnWhatsApp: "اسأل عبر واتساب",
      share: "مشاركة",
      copyLink: "نسخ الرابط",
      copied: "تم النسخ!",
      cartTitle: "السلة",
      cartEmpty: "سلتك فارغة",
      cartEmptyHint: "تصفّح المتجر وأضف منتجاتك المفضّلة.",
      continueShopping: "متابعة التسوق",
      clearCart: "إفراغ السلة",
      subtotal: "المجموع الفرعي",
      shippingLebanon: "التوصيل داخل لبنان — خلال 24 إلى 48 ساعة",
      total: "المجموع",
      checkoutCta: "إتمام الطلب",
      policyTitle: "سياسة الإرجاع والاستبدال",
      policyBody:
        "لا يمكن إرجاع المنتجات. لكن يمكنك استبدال المنتج بمنتج آخر خلال 3 أيام من استلام الطلب مع دفع عمولة الدليفري.",
      policyShort: "لا إرجاع. الاستبدال خلال 3 أيام (مع دفع عمولة الدليفري).",
      quantity: "الكمية",
      description: "الوصف",
      backToStore: "العودة إلى المتجر",
      noResults: "لا توجد منتجات تطابق الفلاتر.",
      noResultsHint: "حاول إزالة أحد الفلاتر أو مسح البحث.",
      productNotFound: "المنتج غير موجود.",
      relatedTitle: "قد يعجبك أيضاً",
      badgeNew: "جديد",
      badgeLimited: "محدود",
      badgeAuthentic: "منتج أصلي",
      priceTBD: "السعر قريباً",
      priceTBDFull: "سيتم تحديث السعر قريباً",
      colorLabel: "اللون",
      selectColor: "اختر اللون",
      colorOutOfStock: "غير متوفر",
      maxStockReached: "تم الوصول للحد الأقصى المتوفر",
      sizeLabel: "المقاس",
      selectSize: "اختر المقاس",
      sizesAvailable: "مقاسات متاحة",
      pieceLeft: "قطعة متبقية",
      piecesLeft: "قطع متبقية",
      trust1: "منتجات أصلية",
      trust2: "توصيل لكل لبنان",
      trust3: "دعم واتساب 24/7",
      helpOnWhatsapp: "تحتاج مساعدة؟ تواصل معنا عبر واتساب",
      inquireMsg: "مرحباً BOB Services LB، أنا مهتم بالمنتج #{id} — {name}.\nالرابط: {url}",
      checkout: {
        title: "إتمام الطلب",
        yourOrder: "طلبك",
        contactInfo: "معلومات العميل",
        paymentMethods: "طريقة الدفع",
        omt: "OMT",
        omtSub: "إرسال عبر فروع OMT",
        whish: "Whish Money",
        whishSub: "تطبيق الدفع عبر الموبايل",
        cod: "الدفع عند الاستلام",
        codSub: "ادفع عند استلامك المنتج",
        fullName: "الاسم الكامل",
        phone: "رقم الهاتف",
        address: "العنوان (اختياري)",
        city: "المدينة / المنطقة (اختياري)",
        notes: "ملاحظات الطلب (اختياري)",
        notesPlaceholder: "هل هناك شيء يجب أن نعرفه عن طلبك؟",
        placeOrder: "تأكيد الطلب",
        placing: "جاري إرسال الطلب...",
        orderSuccess: "تم استلام طلبك!",
        orderSuccessMsg: "شكراً لك! تم تأكيد الطلب رقم {order_no}. سنتواصل معك قريباً عبر واتساب لإتمام التوصيل.",
        orderError: "حدث خطأ. حاول مرة أخرى أو راسلنا على واتساب.",
        unavailableItemsMessage: "بعض المنتجات لم تعد متوفرة. يرجى إزالة المنتجات غير المتوفرة فقط للمتابعة.",
        unavailableItemsBadge: "غير متوفر",
        removeUnavailableCta: "إزالة المنتجات غير المتوفرة",
        requiredField: "هذا الحقل مطلوب",
        invalidPhone: "الرجاء إدخال رقم هاتف صحيح",
        close: "إغلاق",
        backToShopping: "العودة للتسوق",
        items: "منتجات",
        item: "منتج",
        qtyLabel: "الكمية",
      },
    },
    shein: {
      navPillLabel: "شي إن",
      heroTitle: "مجموعة شي إن",
      heroSubtitle: "أحدث الموضة والتجميل ومنتجات الحياة اليومية — مختارة بعناية من شي إن ومُوصلة في كل لبنان خلال 24–48 ساعة.",
      discountChip: "خصم 30% على جميع منتجات شي إن",
      backToBobStore: "العودة إلى متجر BOB",
      featureFastShip: "توصيل خلال 24–48 ساعة في لبنان",
      featureSecure: "دفع آمن وتتبّع الطلب",
      featureCount: "{count} منتج متوفّر",
      searchPlaceholder: "ابحث في منتجات شي إن…",
      subcatAll: "كل منتجات شي إن",
      featuredEyebrow: "إطلالات مميّزة",
      featuredHint: "اضغط لتسوّق الإطلالة",
      featuredShopCta: "تسوّق الآن",
      featuredGoTo: "اذهب إلى الشريحة",
    },
  },
  fr: {
    nav: {
      home: "Accueil",
      howItWorks: "Comment ça marche",
      countries: "Pays",
      why: "Pourquoi nous",
      rates: "Tarifs",
      team: "Notre équipe",
      faq: "FAQ",
      contact: "Contact",
      startShopping: "Acheter & Expédier",
      shippingOnly: "Envoi uniquement",
      stockStore: "Boutique BOB",
      signIn: "Connexion",
      myAccount: "Mon compte",
      myOrders: "Commandes Bob Store",
      myFinancial: "Tableau de bord",
      logout: "Se déconnecter",
    },
    hero: {
      badge: "Le service de transit premium au Liban",
      titlePre: "Achetez partout dans le monde.",
      titleHighlight: "Livré au Liban.",
      subtitle: "Nous achetons, regroupons et expédions vos produits depuis la Turquie, la Chine, les États-Unis, les Émirats, la France et le Royaume-Uni — directement à votre porte. Rapide, fiable, pensé pour le Liban.",
      cta1: "Acheter & Expédier",
      cta2: "Discuter sur WhatsApp",
      ctaStore: "Boutique BOB",
      trustPill: "Plus de 27 000 clients au Liban nous font confiance",
      stats: [
        { k: "27K+", v: "Colis livrés" },
        { k: "6", v: "Pays d'origine" },
        { k: "15 jours", v: "Délai moyen" },
        { k: "24/7", v: "Support en direct" },
      ],
      badgeSecured: "Sécurisé",
      badgeAir: "Fret aérien",
      badgeSea: "Fret maritime",
      heroTagline: "Transport terrestre et maritime",
    },
    how: {
      eyebrow: "Comment ça marche",
      title: "Quatre étapes simples jusqu'à votre porte.",
      subtitle: "Du moment où vous nous envoyez un lien jusqu'à l'arrivée du colis au Liban — nous gérons chaque détail.",
      steps: [
        { n: "01", title: "Choisissez votre pays", desc: "Turquie, Chine, États-Unis, Émirats, France ou Royaume-Uni — où se trouve votre boutique préférée." },
        { n: "02", title: "Envoyez le lien du produit", desc: "Partagez l'article sur WhatsApp avec taille, couleur et quantité. Nous confirmons le prix et les frais." },
        { n: "03", title: "Nous achetons ou recevons", desc: "Notre équipe achète pour vous ou reçoit votre colis dans notre entrepôt local." },
        { n: "04", title: "Livré au Liban", desc: "Nous consolidons, expédions par avion, dédouanons et livrons à votre porte partout au Liban." },
      ],
    },
    countries: {
      eyebrow: "Achats par pays",
      title: "Six marchés. Un seul partenaire de confiance.",
      subtitle: "Des boutiques d'Istanbul aux électroniques de Shenzhen — nous vous apportons le monde.",
      shopCta: "Acheter depuis",
      items: [
        { code: "TR", name: "Turquie", tagline: "Mode, cuir, textile maison" },
        { code: "CN", name: "Chine", tagline: "Électronique, tech, gros" },
        { code: "US", name: "États-Unis", tagline: "Sneakers, beauté, designer" },
        { code: "AE", name: "Émirats", tagline: "Or, parfums, marques premium" },
        { code: "FR", name: "France", tagline: "Luxe, cosmétiques, couture" },
        { code: "GB", name: "Royaume-Uni", tagline: "Mode, streetwear, gadgets" },
      ],
    },
    why: {
      eyebrow: "Pourquoi nous choisir",
      title: "Un partenaire de transit bâti sur la confiance.",
      subtitle: "Nous soignons chaque détail pour que votre colis arrive à l'heure, à chaque fois.",
      items: [
        { title: "Livraison rapide", desc: "La plupart des colis arrivent au Liban en 10 à 15 jours ouvrés par fret aérien fiable." },
        { title: "Transporteur fiable", desc: "Suivi intégral, manutention sécurisée et dédouanement local." },
        { title: "Meilleurs prix", desc: "Tarification transparente, sans frais cachés, avec réductions sur les colis groupés." },
        { title: "Support réactif", desc: "Des humains sur WhatsApp — prêts à aider en arabe, anglais ou français." },
      ],
    },
    categories: {
      eyebrow: "Catégories populaires",
      title: "Ce que nos clients expédient chaque jour.",
      items: ["Mode", "Électronique", "Beauté", "Maison", "Cadeaux", "Accessoires", "Sneakers", "Parfums"],
    },
    testimonials: {
      eyebrow: "Témoignages",
      title: "Plébiscité par les acheteurs au Liban.",
      items: [
        { quote: "J'ai commandé une PlayStation 5 des USA. Arrivée à Beyrouth en 8 jours, parfaitement emballée. Le meilleur prix que j'ai trouvé.", author: "Karim H.", role: "Beyrouth" },
        { quote: "J'utilise BOB chaque mois pour mes achats mode à Istanbul. L'équipe répond vite sur WhatsApp — comme un personal shopper.", author: "Layla M.", role: "Jounieh" },
        { quote: "Des soins de pharmacie française introuvables localement — BOB me les a apportés en une semaine. Mon nouveau transporteur préféré.", author: "Nour A.", role: "Tripoli" },
        { quote: "Tarifs transparents, suivi réel, dédouanement sans souci. Le service le plus professionnel du Liban.", author: "Ziad K.", role: "Saida" },
        { quote: "4 cartons de vêtements depuis la Chine. La consolidation m'a fait économiser plus de 40%. Brillant.", author: "Maya S.", role: "Zahlé" },
        { quote: "J'ai acheté un iPhone à Dubaï et il est arrivé au Liban avant même que les détaillants locaux ne réapprovisionnent. Incroyable.", author: "Omar D.", role: "Byblos" },
      ],
    },
    faq: {
      eyebrow: "FAQ",
      title: "Tout ce que vous devez savoir.",
      items: [
        {
          q: "Comment passer commande ?",
          a: "Envoyez-nous le lien du produit sur WhatsApp avec taille, couleur et quantité. Nous confirmons le prix de l'article, les frais de livraison et nos frais de service. Après validation et paiement, nous achetons pour vous et gérons tout jusqu'à la livraison au Liban.",
        },
        {
          q: "Quel est le délai de livraison au Liban ?",
          a: "La plupart des expéditions depuis la Turquie, les Émirats, la France et le Royaume-Uni arrivent en 10 à 15 jours ouvrés. Les expéditions depuis les USA et la Chine prennent 20 à 25 jours par avion, et 50 à 70 jours par voie maritime.",
        },
        {
          q: "Quels sont les moyens de paiement acceptés ?",
          a: "Nous acceptons le paiement à la livraison au Liban, le transfert en USD via OMT / Whish Money / BoB Wallet, et le virement bancaire pour les grandes commandes. Un acompte de 50% de la valeur de l'achat est requis avant l'achat à l'étranger.",
        },
        {
          q: "Depuis quels pays expédiez-vous ?",
          a: "Nous expédions actuellement depuis la Turquie, la Chine, les USA, les Émirats, la France et le Royaume-Uni. Pour un pays non listé, contactez-nous sur WhatsApp — nous pouvons peut-être vous aider.",
        },
        {
          q: "Livrez-vous partout au Liban ?",
          a: "Oui. Nous livrons à Beyrouth, au Mont-Liban, au Nord, au Sud, à la Békaa et dans toutes les grandes villes. Les frais de livraison varient selon la zone et sont toujours confirmés avant l'expédition.",
        },
        {
          q: "Que se passe-t-il en cas d'article endommagé ou perdu ?",
          a: "Chaque colis est suivi et manipulé par des transporteurs de confiance. En cas de dommage rare pendant le transit, nous travaillons avec nos partenaires pour vous indemniser ou remplacer l'article.",
        },
      ],
      stillQuestions: "D'autres questions ?",
      stillQuestionsSub: "Envoyez-nous un message — nous répondons en quelques minutes.",
    },
    finalCta: {
      eyebrow: "Prêt à commencer ?",
      title: "Votre prochain colis est à un message d'ici.",
      subtitle: "Dites-nous ce que vous voulez, d'où vous le voulez — et on s'occupe du reste.",
      cta1: "Acheter & Expédier",
      cta2: "Nous contacter sur WhatsApp",
    },
    footer: {
      tagline: "Service premium d'achat et de livraison internationale — des plus grands marchés du monde à chaque coin du Liban.",
      quickLinks: "Liens rapides",
      contact: "Contact",
      contacts: "Nos numéros",
      follow: "Suivez-nous",
      office: "Bureau",
      email: "E-mail",
      viewOnMap: "Voir sur la carte",
      rights: "Tous droits réservés.",
      madeIn: "Conçu avec soin au Liban.",
      address: "Nous couvrons tout le Liban",
    },
    rates: {
      eyebrow: "Tarifs & Services",
      title: "Grille tarifaire complète — mise à jour régulièrement.",
      subtitle: "Consultez notre grille interactive par pays, catégorie et mode d'expédition.",
      preview: "Voir les tarifs",
      view: "Voir les tarifs",
      openLink: "Ouvrir en page complète",
      download: "Télécharger le PDF",
      noteTitle: "Frais de service",
      noteBody: "Des frais de service de 12,5% s'appliquent sur la valeur de la facture. Fret maritime disponible pour la Turquie et la Chine ; fret aérien pour tous les pays.",
    },
    videos: {
      eyebrow: "Dans les coulisses",
      title: "Découvrez-nous en action.",
      subtitle: "Des images réelles de nos entrepôts, de notre équipe et de nos opérations.",
      soon: "Vidéos bientôt disponibles.",
    },
    team: {
      eyebrow: "À propos",
      title: "Découvrez notre équipe",
      subtitle: "Notre succès repose sur une équipe de professionnels dévoués, qui travaillent ensemble pour offrir les meilleurs résultats à nos clients.",
    },
    calculator: {
      eyebrow: "Calculateur d'expédition",
      title: "Estimez votre coût d'expédition.",
      subtitle: "Estimations rapides et transparentes basées sur notre grille tarifaire.",
      method: "Mode d'expédition",
      category: "Catégorie du produit",
      weight: "Poids",
      weightUnit: "kg",
      volume: "Volume",
      volumeUnit: "m³",
      invoice: "Valeur de la facture (optionnel)",
      invoiceHint: "Utilisée pour calculer les frais de service de 12,5%.",
      transit: "Délai de transit",
      shippingCost: "Coût d'expédition",
      serviceFee: "Frais de service (12,5%)",
      total: "Total estimé",
      orderCta: "Commander cette expédition",
      disclaimer: "Les estimations sont indicatives — le prix final est confirmé sur WhatsApp.",
      enterWeight: "Entrez un poids supérieur à 0.",
    },
    devCredit: {
      preLabel: "Développé par",
      name: "BOB Services LB",
      cta: "Envie d'un site comme celui-ci ?",
      waLabel: "Nous contacter",
    },
    common: common_strings.fr,
    countryPage: {
      back: "Retour à l'accueil",
      breadcrumbHome: "Accueil",
      breadcrumbCountries: "Pays",
      intro: "Boutiques sélectionnées",
      storesCount: "boutiques",
      currency: "Devise",
      searchPlaceholder: "Rechercher une boutique ou une catégorie",
      visitStore: "Visiter la boutique",
      orderVia: "Commander sur WhatsApp",
      cantFind: "Vous ne trouvez pas votre boutique ?",
      cantFindDesc: "Envoyez-nous un lien produit — nous l'achetons dans n'importe quelle boutique en ligne au monde.",
      sendLink: "Envoyer un lien",
      otherCountries: "Découvrir d'autres pays",
      shopFrom: "Acheter depuis",
      allCategories: "Tout",
      noResults: "Aucune boutique ne correspond à votre recherche.",
      popular: "Populaire en ce moment",
      popularSub: "Les boutiques les plus commandées cette semaine depuis le Liban.",
      popularBadge: "Populaire",
      lead: {
        eyebrow: "Demander un devis",
        title: "Envoyez-nous votre lien produit",
        subtitle: "Remplissez le formulaire — nous vous répondons sur WhatsApp en quelques minutes avec le meilleur prix.",
        name: "Votre nom",
        namePlaceholder: "ex. Karim Haddad",
        phone: "Numéro WhatsApp",
        phonePlaceholder: "+961 70 123 456",
        link: "Lien du produit",
        linkPlaceholder: "https://...",
        submit: "Envoyer la demande",
        submitting: "Envoi...",
        successTitle: "Demande reçue",
        successMsg: "Nous répondrons sur WhatsApp très bientôt. Ouverture du chat…",
        errorMsg: "Un problème est survenu. Essayez directement sur WhatsApp.",
        validationRequired: "Ce champ est obligatoire.",
        validationLink: "Veuillez entrer une URL valide commençant par http ou https.",
        privacy: "En soumettant, vous acceptez d'être contacté sur WhatsApp.",
      },
      chinaSuppliersTitle: "Base de données des fournisseurs en Chine",
      chinaSuppliersDesc: "Parcourez notre annuaire vérifié d'usines, fabricants et grossistes de confiance à travers la Chine.",
      chinaSuppliersCta: "Ouvrir la base fournisseurs",
    },
    embeds: {
      back: "Retour",
      copyLink: "Copier le lien",
      copied: "Copié !",
      share: "Partager",
      shippingOnly: "Envoi uniquement",
      shippingRates: "Tarifs de livraison",
      chinaSuppliers: "Base fournisseurs Chine",
    },
    store: {
      eyebrow: "Boutique BOB",
      pageTitle: "Produits disponibles — prêts à livrer.",
      pageSubtitle: "Produits premium en stock avec promotion -50%. Touchez un article pour voir les détails, l'ajouter au panier ou nous écrire directement.",
      previewEyebrow: "Boutique BOB",
      previewTitle: "Achetez des produits premium — directement chez BOB.",
      previewSubtitle: "Une sélection de notre boutique, prête à être livrée partout au Liban en 24 à 48 heures.",
      previewViewAll: "Voir toute la boutique",
      recentlyViewedEyebrow: "Pour vous",
      recentlyViewedTitle: "Vus récemment",
      recentlyViewedPrev: "Éléments précédents",
      recentlyViewedNext: "Éléments suivants",
      recentlyViewedRemove: "Retirer des produits vus récemment",
      bannerEyebrow: "Promotion à durée limitée",
      bannerHeadline: "50% DE RÉDUCTION",
      bannerSub: "Sur tous les produits",
      bannerFootnote: "Réduction appliquée automatiquement",
      categoryAll: "Tous",
      categories: {
        clothing: "Vêtements et chaussures",
        perfumes: "Parfums",
        cosmetics: "Compléments et cosmétiques",
        others: "Autres",
        authentic: "Marques authentiques",
      },
      searchPlaceholder: "Rechercher par nom ou #numéro",
      availableOnly: "En stock uniquement",
      sortBy: "Trier par",
      sortDefault: "Tri : par défaut",
      sortPriceLow: "Prix : croissant",
      sortPriceHigh: "Prix : décroissant",
      available: "Disponible",
      outOfStock: "Rupture de stock",
      addToCart: "Ajouter au panier",
      addedToCart: "Ajouté au panier",
      inquireOnWhatsApp: "Demander sur WhatsApp",
      share: "Partager",
      copyLink: "Copier le lien",
      copied: "Copié !",
      cartTitle: "Panier",
      cartEmpty: "Votre panier est vide",
      cartEmptyHint: "Parcourez la boutique et ajoutez vos articles préférés.",
      continueShopping: "Continuer vos achats",
      clearCart: "Vider le panier",
      subtotal: "Sous-total",
      shippingLebanon: "Livraison au Liban — 24 à 48 heures",
      total: "Total",
      checkoutCta: "Commander",
      policyTitle: "Politique de retour et d'échange",
      policyBody:
        "Les retours ne sont pas autorisés. Cependant, vous pouvez échanger le produit contre un autre dans un délai de 3 jours après réception de la commande, avec paiement des frais de livraison.",
      policyShort: "Pas de retour. Échange sous 3 jours (frais de livraison applicables).",
      quantity: "Quantité",
      description: "Description",
      backToStore: "Retour à la boutique",
      noResults: "Aucun produit ne correspond aux filtres.",
      noResultsHint: "Essayez de retirer un filtre ou de vider la recherche.",
      productNotFound: "Produit introuvable.",
      relatedTitle: "Vous pourriez aussi aimer",
      badgeNew: "Nouveau",
      badgeLimited: "Limité",
      badgeAuthentic: "Produit authentique",
      priceTBD: "Prix à venir",
      priceTBDFull: "Prix à mettre à jour",
      colorLabel: "Couleur",
      selectColor: "Choisir la couleur",
      colorOutOfStock: "Rupture de stock",
      maxStockReached: "Quantité maximale disponible atteinte",
      sizeLabel: "Taille",
      selectSize: "Choisir la taille",
      sizesAvailable: "tailles disponibles",
      pieceLeft: "pièce restante",
      piecesLeft: "pièces restantes",
      trust1: "Produits authentiques",
      trust2: "Livraison partout au Liban",
      trust3: "Support WhatsApp 24/7",
      helpOnWhatsapp: "Besoin d'aide ? Contactez-nous sur WhatsApp",
      inquireMsg: "Bonjour BOB Services LB, je suis intéressé(e) par le produit #{id} — {name}.\nLien : {url}",
      checkout: {
        title: "Commander",
        yourOrder: "Votre commande",
        contactInfo: "Informations client",
        paymentMethods: "Mode de paiement",
        omt: "OMT",
        omtSub: "Envoi via les agences OMT",
        whish: "Whish Money",
        whishSub: "Paiement mobile",
        cod: "Paiement à la livraison",
        codSub: "Payez à la réception",
        fullName: "Nom complet",
        phone: "Numéro de téléphone",
        address: "Adresse (facultatif)",
        city: "Ville / zone (facultatif)",
        notes: "Notes de commande (facultatif)",
        notesPlaceholder: "Quelque chose à savoir sur votre commande ?",
        placeOrder: "Valider la commande",
        placing: "Envoi en cours...",
        orderSuccess: "Commande reçue !",
        orderSuccessMsg: "Merci ! Commande {order_no} confirmée. Nous vous contacterons sur WhatsApp pour finaliser la livraison.",
        orderError: "Une erreur est survenue. Réessayez ou contactez-nous sur WhatsApp.",
        unavailableItemsMessage: "Certains articles ne sont plus disponibles. Veuillez supprimer uniquement les articles indisponibles pour continuer.",
        unavailableItemsBadge: "Indisponible",
        removeUnavailableCta: "Supprimer les articles indisponibles",
        requiredField: "Ce champ est requis",
        invalidPhone: "Veuillez saisir un numéro de téléphone valide",
        close: "Fermer",
        backToShopping: "Retour aux achats",
        items: "articles",
        item: "article",
        qtyLabel: "Qté",
      },
    },
    shein: {
      navPillLabel: "SHEIN",
      heroTitle: "Collection SHEIN",
      heroSubtitle: "Mode, beauté et lifestyle — une sélection SHEIN soignée, livrée partout au Liban en 24 à 48 heures.",
      discountChip: "30% de réduction sur tous les produits SHEIN",
      backToBobStore: "Retour à la boutique BOB",
      featureFastShip: "Livraison 24–48h au Liban",
      featureSecure: "Paiement sécurisé & suivi de commande",
      featureCount: "{count} produits en stock",
      searchPlaceholder: "Rechercher dans SHEIN…",
      subcatAll: "Tout SHEIN",
      featuredEyebrow: "Looks en vedette",
      featuredHint: "Touchez pour acheter le look",
      featuredShopCta: "Acheter",
      featuredGoTo: "Aller à la diapositive",
    },
  },
};

export const LANG_ORDER = ["en", "ar", "fr"];
export const LANG_LABELS = { en: "EN", ar: "العربية", fr: "FR" };
export const LANG_FULL = { en: "English", ar: "العربية", fr: "Français" };
